import React, {useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import { ThemeProvider } from './theme/ThemeContext';

// Components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import About from "./components/About";
import Pricing from "./components/Pricing";
import Footer from "./components/Footer";

// Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import DataDeletion from "./pages/DataDeletion";
import ClinicalLogic from "./components/ClinicalLogic";
import { initGA, logPageView } from './utils/analytics'; // Import our helper

// We extract the main marketing page into its own component
function LandingPage() {
    return (
        <>
            <Hero />
            <Features />
            <About />
            <ClinicalLogic />
            <Pricing />
        </>
    );
}

// Create a component specifically to handle route tracking
function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        // Initialize Google Analytics once
        initGA();
    }, []);

    useEffect(() => {
        // Log a page view every time the URL changes
        logPageView(location.pathname + location.search);
    }, [location]);

    return null; // This component doesn't render anything visually
}

function AppContent() {
    return (
        <div className="min-h-screen flex flex-col bg-[var(--color-brand-background)] text-[var(--color-brand-text)] font-sans selection:bg-[var(--color-brand-primary)] selection:text-white transition-colors duration-300">

            <AnalyticsTracker />
            {/* Persistent Top Navigation */}
            <Navbar />

            {/* Dynamic Route Content */}
            <main className="flex-grow">
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/data-deletion" element={<DataDeletion />} />
                </Routes>
            </main>

            {/* Persistent Footer */}
            <Footer />

        </div>
    );
}

export default function App() {
    return (
        <ThemeProvider>
            <Router>
                <AppContent />
            </Router>
        </ThemeProvider>
    );
}